/**
 * ChainVault WP - Buy Crypto Page (Transak)
 *
 * Embeds the Transak widget for buying crypto with fiat (card, bank transfer).
 * Admin configures their Transak API key and supported networks in
 * Admin -> ChainVault -> Advanced.
 *
 * @package ChainVault
 * @since   1.0.0
 */
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';

export default function BuyPage() {
    const navigate  = useNavigate();
    const iframeRef = useRef( null );
    const { address, builtInWallet, walletType, selectedNetwork } = useWallet();

    const transakApiKey = window.chainvaultSettings?.transakApiKey || '';
    const isTestnet     = localStorage.getItem( 'chainvault_testnet_mode' ) === '1';

    const walletAddress = walletType === 'builtin' && builtInWallet
        ? ( selectedNetwork === 'solana' ? builtInWallet.solana?.address : builtInWallet.ethereum?.address )
        : address || '';

    const network = selectedNetwork === 'solana' ? 'solana' : 'ethereum';

    const transakUrl = `https://${ isTestnet ? 'staging-global' : 'global' }.transak.com/?` + new URLSearchParams({
        apiKey:          transakApiKey || 'STAGING_KEY',
        network:         network,
        walletAddress:   walletAddress || '',
        disableWalletAddressForm: walletAddress ? 'true' : 'false',
        defaultCryptoCurrency: selectedNetwork === 'solana' ? 'SOL' : 'ETH',
        themeColor:      '7C63FF',
        colorMode:       'DARK',
    }).toString();

    return (
        <div style={{ display:'flex', flexDirection:'column', height:'100vh', background:'#0a0a14' }}>
            {/* Header */}
            <div style={{ display:'flex', alignItems:'center', gap:'12px', padding:'14px 16px', borderBottom:'1px solid rgba(255,255,255,0.08)' }}>
                <button onClick={ () => navigate(-1) } style={{ background:'rgba(255,255,255,0.08)', border:'none', borderRadius:'50%', width:36, height:36, color:'#fff', fontSize:18, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}>←</button>
                <span style={{ color:'#fff', fontWeight:'700', fontSize:16 }}>Buy Crypto</span>
                <span style={{ marginLeft:'auto', fontSize:11, color:'#666' }}>Powered by Transak</span>
            </div>

            { ! transakApiKey ? (
                <div style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'32px', textAlign:'center' }}>
                    <div style={{ fontSize:'48px', marginBottom:'16px' }}>💳</div>
                    <h2 style={{ color:'#fff', marginBottom:'8px' }}>Buy Crypto with Card</h2>
                    <p style={{ color:'#888', fontSize:'13px', marginBottom:'24px', lineHeight:'1.6' }}>
                        To enable buying crypto with a debit/credit card or bank transfer, the site admin needs to add a Transak API key in WordPress Admin → ChainVault → Advanced.
                    </p>
                    <a href="https://transak.com" target="_blank" rel="noopener noreferrer" style={{ color:'#7C63FF', fontSize:'13px' }}>
                        Get a free Transak API key →
                    </a>
                </div>
            ) : (
                <iframe
                    ref={ iframeRef }
                    src={ transakUrl }
                    style={{ flex:1, border:'none', width:'100%' }}
                    title="Buy Crypto with Transak"
                    allow="camera;microphone;payment"
                />
            )}
        </div>
    );
}
